import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import '../App.css';

const BackToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`back-to-top fixed bottom-8 right-8 z-40 p-4 bg-dark-accent hover:bg-dark-accentHover text-white rounded-full shadow-lg transition-all duration-300 ${
        isVisible ? 'visible' : ''
      }`}
      aria-label="Voltar ao topo"
    >
      <ArrowUp size={24} className="w-6 h-6" />
    </button>
  );
};

export default BackToTop;

